// @owners { team: patients }

// Same CloudFront distributions the web app already deploys through — see
// apps/web/bin/common.sh's getCdnUrlForEnv. Duplicated here (rather than a shared
// source of truth) since these domains are effectively permanent and only reachable
// from bash in that script; keep in sync if that infra ever changes.
const PROD_CDN_URL = 'https://d17ergeyp5gj5y.cloudfront.net';
const NON_PROD_CDN_URL = 'https://d3cuyjequulw.cloudfront.net';

type BackendEnvironment = 'local' | 'sandbox' | 'staging' | 'integration' | 'production';

// Nested under the same patient-app/{prod,sandbox} prefixes the web app's own deploys use (see
// getCdnNamespaceForEnv in apps/web/bin/common.sh), but with a fixed, non-branch-namespaced
// scheduled_downtime/ subfolder so it can be updated independently of any deploy. Must match this
// exactly -- it's also the exact path the write-access IAM policy for bin/scheduled-downtime/ scopes
// to, so changing it here without also updating that policy will break uploads.
export const getScheduledDowntimeUrl = (env: BackendEnvironment): string => {
  const cdnUrl = env === 'production' ? PROD_CDN_URL : NON_PROD_CDN_URL;
  const namespace =
    env === 'production' ? 'patient-app/prod/scheduled_downtime' : 'patient-app/sandbox/scheduled_downtime';
  return `${cdnUrl}/${namespace}/scheduled-downtime.json`;
};
